module.exports = __webpack_public_path__ + "img/osfatun-1-blanco.ebaf65fa.svg";